<template>
	<div class="chat" v-loading="loading">

		<template v-if="!conectando">

			<div class="header">

				<div class="user">

					<span v-if="partner.id">

						<i class="el-icon-user"></i> {{ partner.name }}

					</span>

					<span v-else>Bienvenido {{ user.name }}</span>

				</div>

				<div class="chat-action">

					<i
						v-show="partner.id"
						class="el-icon-video-camera"
						@click="onCamera(partner)"
					></i>

					<i
						class="el-icon-chat-dot-square"
						:class="{ aviso: avisoContacts > 0 }"
						@click="showContacts = !showContacts"
					></i>

				</div>

			</div>

			<ChatCamara
				ref="camera"
				:ws="ws"
				:partner="partner"
				@dialog="opts => $refs.dialog.open(opts)"
				@partner="onPartner"
			/>

			<ChatPrincipal
				v-if="partner.id"
				ref="principal"
				:user="user"
				:ws="ws"
				:partner="partner"
				@dialog="opts => $refs.dialog.open(opts)"
			/>

			<ChatHistorial
				v-else
				:user="user"
				:ws="ws"
				:partner="partner"
				@dialog="opts => $refs.dialog.open(opts)"
				@camera="onCamera"
				@partner="onPartner"
			/>

			<ChatUsuarios
				:showContacts.sync="showContacts"
				:ws="ws"
				:user="user"
				:partner="partner"
				@partner="onPartner"
				@aviso="onAviso"
				@dialog="opts => $refs.dialog.open(opts)"
			/>

			<ChatDialog ref="dialog"/>

		</template>

	</div>
</template>

<script>
	import websocket from '../utils/websocket'
	import ChatPrincipal from './ChatPrincipal.vue'
	import ChatUsuarios from './ChatUsuarios.vue'
	import ChatCamara from './ChatCamara.vue'
	import ChatDialog from './ChatDialog.vue'
	import ChatHistorial from './ChatHistorial.vue'

	export default {
		name: 'Chat',
		components: {
			ChatPrincipal,
			ChatUsuarios,
			ChatCamara,
			ChatDialog,
			ChatHistorial
		},
		props: {
			user: {
				type: Object,
				required: true
			},
			wsUrl: {
				type: String,
				required: true
			},
			moment: {}
		},
		data () {
			return {
				ws: null,
				conectando: true,
				partner: {},
				showContacts: false,
				loading: false,
				avisoContacts: 0,
				title: ''
			}
		},
		watch: {

			avisoContacts (val) { document.title = val === 0 ? this.title : `${this.title} (${val})` }

		},
		created () {

			this.title = document.title

			this.conectarWS()

		},
		beforeDestroy () {

			this.ws.delMsg('login', this.onLogin)

			this.ws.close()

		},
		methods: {

			onAviso (val) { this.avisoContacts = val },

			conectarWS () {

				this.conectando = true

				this.ws = websocket(this.wsUrl, this.user)

				this.ws.onMsg('login', this.onLogin)

				this.ws.addEventListener('close', () => { this.conectarWS() })

			},

			onPartner (partner) {

				this.partner = partner

				this.showContacts = false

			},

			onLogin () {

				this.conectando = false

			},

			onCamera(partner = false) {

				partner = partner ? partner : this.partner

				this.$refs.dialog.open({
					title: 'Llamar a usuario',
					msg: `¿Iniciar llamada con ${partner.name}?`,
					acceptText: 'Llamar',
					cancelText: 'Cancelar',
					accept: () => { this.$refs.camera.click(partner) }
				})

			}

		}
	}

</script>

<style lang="scss">

	.chat, .chat>*, .chat * {
		box-sizing: border-box;
		min-height: 0;
		min-width: 0;
	}

	.chat {
		height: 100%;
		background-color: #f7f7f7;
		border-radius: 4px;
		display: flex;
		flex-direction: column;

		.header {
			background-color: #4a596a;
			height: 50px;
			flex-shrink: 0;
			border-radius: 4px 4px 0 0;
			display: flex;
			align-items: center;
			justify-content: space-between;
			padding: 0 20px;
			color: white;

			.chat-action {
				display: flex;
				align-items: center;
				i {
					font-size: 1.3rem;
					cursor: pointer;
					margin-left: 15px;
					position: relative;

					&.aviso:after {
						content: '';
						background-color: red;
						position: absolute;
						width: .6rem;
						height: .6rem;
						top: -.25rem;
						right: -.25rem;
						border-radius: 999px;
					}
				}
			}

		}

		.chat-camera {
			background-color:black;
			flex-shrink: 0;
			padding: 10px;
			text-align: center;

			.estado {
				color: white;
				margin-bottom: 10px;
			}

			.videos {
				position: relative;

				&>div {
					position: absolute;
					left: 0;
					right: 5px;
					bottom: 5px;
					text-align: right;
				}

				video.peer-video {
					height: 280px;
				}

				video.my-video {
					height: 100px;
					border: 1px solid black;
					outline: 1px solid white;
				}
			}

		}

		.chat-principal {
			height: 100%;
			display: flex;
			flex-direction: column;

			.content {
				flex-grow: 1;
				overflow: auto;

				.msg-dia {
					display: flex;
					flex-flow: wrap;
					justify-content: center;
					position: sticky;
					top: 0;
					z-index: 999;

					p{
						border-radius: 4px;
						padding: 7px;
						margin: 5px;
						background-color: #fdd6ff;
						box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0, 0, 0, 0.06);
						font-size: .9rem;
						line-height: .9rem;
					}
				}

				ul {
					margin: 0;
					padding: 10px 0 0 0;
					list-style: none;

					li {
						width: 100%;
						margin-bottom: 5px;
						&.msg-left {
							padding-left: 5px;
							.msg-content {
								p {
									padding-right: 40px;
								}
							}
						}
						&.msg-center {
							padding: 0 5px;
							display: flex;
							flex-flow: wrap;
							justify-content: center;
							.msg-content {
								background-color: #fdffe5;
								p {
									padding-right: 40px;
								}
							}
						}
						&.msg-right {
							padding-right: 5px;
							display: flex;
							flex-flow: wrap;
							justify-content: flex-end;
							.msg-content {
								background-color: #f3f7fa;
								p {
									padding-right: 40px;
								}
							}
						}
						.msg-content {
							background-color: white;
							box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0, 0, 0, 0.06);
							border-radius: 4px;
							padding: 5px;
							margin: 3px 3px 5px 3px;
							display: flex;
							flex-flow: column;
							max-width: 80%;
							width: fit-content;
							position: relative;
							p {
								margin: 0;
								font-size: 0.8rem;
							}
							span {
								font-size: 0.6rem;
								text-align: right;
								line-height: 0.5;
								opacity: 0.7;
							}
						}
					}
				}
			}

			.chat-send {
				display: flex;
				padding: 10px;
				border-radius: 0 0 4px 4px;
				flex-shrink: 0;

				button {
					border: 0;
					font-size: 20px;
					width: 45px;
					background-color: #4a596a;
					color: #ffffff;
					border-radius: 3px;
					margin-left: 5px;
					cursor: pointer;
				}
			}
		}

		.chat-historial {

			ul {
				overflow-y: auto;
				overflow-x: auto;
				list-style: none;
				margin: 0;
				padding: 0;

				li {
					padding: 14px 20px;
					border-bottom: 1px solid #e4e4e4;
					cursor: pointer;
					display: flex;
					align-items: center;
					justify-content: space-between;

					i {
						position: relative;
					}

					.aviso>i:after {
						content: '';
						background-color: red;
						position: absolute;
						width: .4rem;
						height: .4rem;
						top: -.2rem;
						right: -.2rem;
						border-radius: 999px;
					}

					&.active {
						background-color: #f0f0f0;
					}

					&.aviso>i:after {
						content: '';
						background-color: red;
						position: absolute;
						width: .4rem;
						height: .4rem;
						top: -.2rem;
						right: -.2rem;
						border-radius: 999px;
					}

					&:last-child {
						border: 0;
					}

					&:hover {
						background-color:#f0f0f0;
					}
				}
			}

		}

		//Contacts
		.chat-usuarios {

			*:focus {
				outline: 0;
			}

			.contacts {
				overflow-y: auto;
				overflow-x: auto;
				list-style: none;
				margin: 0;
				padding: 0;

				li {
					padding: 14px 20px;
					border-bottom: 1px solid #e4e4e4;
					cursor: pointer;

					i {
						position: relative;
					}

					&.active {
						background-color: #f0f0f0;
					}

					&.aviso>i:after {
						content: '';
						background-color: red;
						position: absolute;
						width: .4rem;
						height: .4rem;
						top: -.2rem;
						right: -.2rem;
						border-radius: 999px;
					}

					&:last-child {
						border: 0;
					}

					&:hover {
						background-color:#f7f7f7;
					}
				}
			}
		}

	}
</style>
